import { Component, inject, OnInit, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { ModalFeedbackComponent } from '../../modals/modal-feedback/modal-feedback.component';
import { GlobalMessageComponent } from '../../modals/global-message/global-message.component';
import { ContainerComponent } from '../container/container.component';
import { PaginatorComponent } from '../../ui/paginator/paginator.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AnnouncementService } from '../../../services/announcement.service';
import { AnnouncementModel } from '../../../models/announcement.models';
import { CommonModule, DatePipe } from '@angular/common';

@Component({
  selector: 'app-announcement-list',
  imports: [
    CommonModule,
    ContainerComponent,
    PaginatorComponent,
    RouterLink,
    RouterLink,
    RouterLink,
    DatePipe,
    DatePipe,
  ],
  templateUrl: './announcement-list.component.html',
  standalone: true,
  styleUrl: './announcement-list.component.scss',
})
export class AnnouncementListComponent implements OnInit {
  private matDialog = inject(MatDialog);
  private destroy$ = new Subject<void>();
  private announcementService = inject(AnnouncementService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  announcements = signal<AnnouncementModel[]>([]);
  totalItems: number = 0;
  currentPage: number = 1;
  itemsPerPage: number = 8;

  openModal(announcementId: string): void {
    const dialogRef = this.matDialog.open(ModalFeedbackComponent, {
      data: { announcementId },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) {
          this.showGlobalMessage('Дякую', 'Закрити', 'closeModal');
        }
      });
  }

  private showGlobalMessage(
    text: string,
    linkText: string,
    link: string,
  ): void {
    this.matDialog.open(GlobalMessageComponent, {
      data: {
        text,
        linkText,
        link,
      },
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.currentPage = Number(params['page']) || 1;
    });
    this.route.data.subscribe((data) => {
      if (data && data['announcements']) {
        this.announcements.set(data['announcements'].data);
        this.totalItems = data['announcements'].count;
      }
    });
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page },
      queryParamsHandling: 'merge',
    });
    this.getList();
  }

  getList() {
    const params = {
      take: this.itemsPerPage,
      skip: (this.currentPage - 1) * this.itemsPerPage,
      orderBy: 'createdAt',
      orderDirection: 'DESC' as const,
    };

    this.announcementService.getAnnouncementList(params).subscribe((res) => {
      this.announcements.set(res.data);
      this.totalItems = res.count;
      this.updatePaginatedList();
    });
  }

  updatePaginatedList() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.announcements().slice(start, end);
  }
}
